module.exports = __webpack_public_path__ + "img/29.b2a458c9.jpg";